/**
 * Insights card for the Reporting Pathway Report (MVP module Phase F).
 * Deliberately light: no engine run here — the card is a doorway, the report
 * computes on open. Shows availability by viewing year (MVPs exist 2026+).
 */
import { useNavigate } from 'react-router-dom';
import { Route } from 'lucide-react';
import { useProgramYear } from '@/contexts/ProgramYearContext';
import { MipsDataService } from '@/lib/mips-data-service';
import { ReportCard } from '../ReportCard';

export function PathwayReportCard() {
  const navigate = useNavigate();
  const { programYear } = useProgramYear();
  const available = MipsDataService.getInstance().hasMvpDataset(programYear);

  const preview = (
    <div className="text-center py-3">
      <p className="text-3xl font-bold">28</p>
      <p className="text-xs text-muted-foreground mt-1">
        {available
          ? `pathways projected & ranked for PY${programYear}`
          : `pathways — available from PY2026 (viewing PY${programYear})`}
      </p>
    </div>
  );

  return (
    <ReportCard
      title="Reporting Pathway Report"
      description="Which pathway pays best? Projected scores and dollar impact across Traditional MIPS and all 27 MVPs, ranked."
      icon={<Route className="h-6 w-6" />}
      onClick={() => navigate('/insights/pathway-report')}
      status={available ? 'available' : 'coming-soon'}
      preview={preview}
    />
  );
}
